import { HelpModal, HelpModalProps } from '@mi-front/ui';
import { FormattedMessage } from 'react-intl';

/**
 * Help content for the groups feature. All copy is driven by locale keys
 * so every language (en, de, fr, pt, es) uses the same component.
 */
export function GroupsHelp(props: Pick<HelpModalProps, 'linkText' | 'trigger'>) {
  return (
    <HelpModal {...props}>
      <FormattedMessage
        id="admin.groups.help.intro"
        defaultMessage="Los <strong>grupos</strong> permiten organizar usuarios y controlar accesos y permisos de radios de manera fácil."
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
        }}
      />
      <br />
      <FormattedMessage
        id="admin.groups.help.assignGroup"
        defaultMessage="Al asignar el grupo a un usuario, éste tendrá acceso a todas las emisoras sobre las que el grupo posee acceso. Puedes administrar los permisos asignados a cada grupo en <strong>Administración {'>'} Estación {'>'} Permisos de grupos</strong>."
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
        }}
      />
      <br />
      <FormattedMessage
        id="admin.groups.help.oneGroup"
        defaultMessage="Un usuario puede pertenecer a sólo <strong>un</strong> grupo. Si necesitas permitir el acceso a un usuario más allá de su grupo, puedes hacerlo asignando un permiso individual en <strong>Administración {'>'} Estación {'>'} Permisos de usuario</strong>."
        values={{
          strong: (chunks) => <strong>{chunks}</strong>,
        }}
      />
    </HelpModal>
  );
}
